import React                     from 'react';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import DateRangeNav              from '../ui/DateRangeNav';
import mainDateRangeNavModel     from './MainDateRangeNavModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  dateContainer: {
  },
  dateNav: {
  },
  endDate: {
  },
  dateDuration: {
  },
  dateError: {
  },
});

interface IMainDateRangeNavProps {
  className?:    string;
  classes?:      any;
  hideDate?:     boolean;
  hideDuration?: boolean;
}

type MainDateRangeNavProps = WithStyle<ReturnType<typeof styles>, IMainDateRangeNavProps>;

class MainDateRangeNav extends React.PureComponent<MainDateRangeNavProps> {
  constructor(props: MainDateRangeNavProps) {
    super(props);
  }

  render() {
    const {className, classes, hideDate, hideDuration} = this.props;

    return (
      <DateRangeNav model={mainDateRangeNavModel} className={className} classes={classes} hideDate={hideDate} hideDuration={hideDuration} />
    );
  }
}

export default withStyles<IMainDateRangeNavProps>(styles, MainDateRangeNav);
